var { isMobile } = require("./lib/breakpoints");

var {
  COLORS,
  makeTranslate,
  classify,
  formatStyle,
  fmtPrice,
} = require("./lib/helpers");

var d3 = {
  ...require("d3-axis/dist/d3-axis.min"),
  ...require("d3-scale/dist/d3-scale.min"),
  ...require("d3-selection/dist/d3-selection.min"),
};

function percentToNumber(pctStr) {
  const number = parseFloat(pctStr.replace("%", ""));

  if (!isNaN(number)) {
    return number;
  }
  return NaN;
}

var renderPrices = function (config) {
  let { container, width, selectedCity, selectedCategory, categoryData } =
    config;

  // const category_values = Object.values(categoryData).map(val => percentToNumber(val.pct_chg))

  // const max_value = Math.max(...category_values)
  // const min_value = Math.min(...category_values)

  // console.log(max_value,min_value)

  var colorScale = d3
    .scaleThreshold()
    .domain([-10, -5, -2.5, 0, 2.5, 5, 10])
    .range([
      COLORS.blue3,
      COLORS.blue4,
      COLORS.blue5,
      COLORS.blue6,
      COLORS.orange6,
      COLORS.orange5,
      COLORS.orange4,
      COLORS.orange3,
    ]);

  let containerElement = d3.select(config.container);
  containerElement.html("");

  var wrapper = containerElement.append("div").attr("class", "prices-wrapper");

  let subcategory_data = Object.keys(categoryData)
    .filter(d => categoryData[d]["y23"] !== "NULL")
    .sort((a, b) => {
      if (a === "Other") return 1;
      if (b === "Other") return -1;
      return a.localeCompare(b);
    });

  let subcategory = wrapper
    .selectAll("div")
    .data(subcategory_data)
    .enter()
    .append("div")
    .attr("class", function (d) {
      if (percentToNumber(categoryData[d]["pct_chg"]) > 0) {
        return "subcategory up";
      } else if (percentToNumber(categoryData[d]["pct_chg"]) < 0) {
        return "subcategory down";
      } else {
        return "subcategory same";
      }
    })
    .style("background-color", d =>
      colorScale(percentToNumber(categoryData[d]["pct_chg"]))
    );

  subcategory.append("h3").text(d => d);

  var numDiv = subcategory.append("div");

  numDiv
    .append("span")
    .html(d =>
      percentToNumber(categoryData[d]["pct_chg"]) > 0
        ? "+" + categoryData[d]["pct_chg"]
        : categoryData[d]["pct_chg"]
    );
};

module.exports = renderPrices;
